import { Program } from '@nemuru-eng/js-api-client';

export enum ProgramSelectOption {
  FREE_PROGRAM = Program.FREE_PROGRAM,
  ZERO_PROGRAM = Program.ZERO_PROGRAM,
  NO_PURCHASE = Program.NO_PURCHASE,
}
